export default chartPotImage

/** @ngInject */
function chartPotImage(Chart) {
    return ({
        restrict: 'E',
        template: require('./view.jade')(),
        scope: {
            pot: '=',
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/chart-pot-image/directive.js